module.exports = __webpack_public_path__ + "static/img/downloadCode.ad0e34f3.png";